import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";

function itemRender(route, params, routes, paths) {
  const last = routes.indexOf(route) === routes.length - 1;
  return last ? (
    <span>{route.breadcrumbName}</span>
  ) : (
    <Link to={paths.join("/")}>{route.breadcrumbName}</Link>
  );
}

class BreadCrumb extends Component {
  render() {
    return <Breadcrumb itemRender={itemRender} routes={this.props.routes} />;
  }
}

export default BreadCrumb;
